module.exports = __webpack_public_path__ + "img/moren_tx.de3eb829.png";